
<template>
	<b-tab title="GARANTIZADO">
		<b-col>
			<div class="text-center">
				<b-img src="images/tabs/desktop/garantizados/garantizados.png" alt="garantizados" style="width: 60%" />
			</div>
			<div class="bg-white py-4 px-2" style="border-radius: 20px">
				<b-table-simple borderless class="m-0">
					<b-tr>
						<b-td class="w-50" style="font-size: 1rem;">
							<div class="text-left d-inline-block">
							<b>PLANES FULL COBERTURA</b><br />
							<span style="font-size: 2.3rem;">Hasta $2.000.000</span>
							</div>
						</b-td>
						<b-td style="font-size: 1rem;">
							Servicios MOK Automotriz coordinará el ingreso de tu vehículo al taller adherido más cercano pagando los costos de reparación. Además incluimos todos los beneficios de Asistencia en Ruta MOK.
						</b-td>
					</b-tr>
				</b-table-simple>
				<div style="border-radius: 20px; border: 2px solid #F1802D">
					<b-table-simple borderless class="m-0">
						<b-tr>
							<b-td style="font-size: 1.3rem; color: #F1802D; vertical-align: middle">
								Servicios Adicionales
							</b-td>
							<b-td style="font-size: 1rem; vertical-align: middle">
								Pago y Traslado Revisión Técnica - Conductor de reemplazo <br />
								Vehículo de reemplazo RM - Asistencia en ruta - Hotel de estadía
							</b-td>
						</b-tr>
					</b-table-simple>
				</div>
				<interested :service_type_id="2" class="mt-2"></interested>
			</div>
		</b-col>
	</b-tab>
</template>

<script>
import Interested from '../components/interested';
export default {
	name: 'v-tab-warrany',
		components:{
			Interested
		},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
